import { render } from "./Fortschritt.vue?vue&type=template&id=2e458e3c&scoped=true"
import script from "./Fortschritt.vue?vue&type=script&lang=js"
export * from "./Fortschritt.vue?vue&type=script&lang=js"

import "./Fortschritt.vue?vue&type=style&index=0&id=2e458e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e458e3c"]])

export default __exports__